// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { SxProps, TextFieldProps } from "@mui/material";
import { Theme } from "@mui/system";
import { DatePicker } from "@mui/x-date-pickers";
import { Control, Controller, ControllerProps } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/tr";

dayjs.locale("tr");

export type DateControlProps = {
  label: string;
} & TextFieldProps;

export interface DatePickerControlProps<TFormFields>
  extends DateControlProps,
  Pick<ControllerProps, "rules"> {
  control: Control<TFormFields, object>;
  helperText?: string;
  type?: React.HTMLInputTypeAttribute | undefined;
  id: Path<TFormFields>;
  label?: string;
  defaultValue?: any;
  size?: "medium" | "small";
  sx?: SxProps<Theme>;
  disabled?: boolean;
}

export function DatePickerControl<TFormFields>(
  props: DatePickerControlProps<TFormFields>
) {
  const {
    control,
    type,
    label,
    rules,
    size = "medium",
    sx,
    defaultValue,
    disabled,
    ...textFieldProps
  } = props;

  return (
    <Controller
      control={control}
      name={textFieldProps.id}
      rules={rules}
      defaultValue={defaultValue ?? null}
      render={({ field: { onChange, name, value }, fieldState: { error } }) => {
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
            <DatePicker
              sx={sx}
              size={size}
              label={label}
              value={value}
              disabled={disabled}
              onChange={onChange}
              slotProps={{
                textField: {
                  error: !!error,
                  helperText: error?.message || "",
                },
              }}
              type={type}
              format="DD.MM.YYYY"
            />
          </LocalizationProvider>
        );
      }}
    />
  );
}
